import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { bindActionCreators } from 'redux'
import { SubmissionError } from 'redux-form'

import { fetchUpdates } from '../actions/updates'

import { renderInputField, renderSelectField } from '../utils/forms'

class UpdatesFilterForm extends React.Component {
  constructor(props) {
    super(props)
    this.submit = this.submit.bind(this)
  }

  submit(props) {
    return this.props.fetchUpdates(props.Machine, props.Status, props.StartDate, props.EndDate)
      .then(response => {
        if (response.error) {
          throw new SubmissionError({
            _error: response.error.message,
            ...response.error.fields
          })
        }

        return response
      })
  }

  render() {
    const { error, submitting, handleSubmit, machineSerials } = this.props

    return (
      <form onSubmit={handleSubmit(this.submit)}>
        <div className="row">
          <div className="col">
            <Field name="Machine"
                   component={renderSelectField}
                   label="Máquina">
              <option value="">Todas</option>
              {machineSerials.map(serial => (
                <option value={serial} key={serial}>
                  {serial}
                </option>
              ))}
            </Field>
          </div>
          <div className="col">
            <Field name="Status"
                   component={renderSelectField}
                   label="Estado">
              <option value="">Todos</option>
              <option value="PENDING">PENDIENTES</option>
              <option value="ONPROCESS">EN PROCESO</option>
              <option value="COMPLETE">COMPLETADOS</option>
              <option value="ERROR">ERROR</option>
              <option value="CANCELED">CANCELADOS</option>
            </Field>
          </div>
          <div className="col">
            <Field name="StartDate"
                   component={renderInputField}
                   type="date"
                   label="Fecha inicio"/>
          </div>
          <div className="col">
            <Field name="EndDate"
                   component={renderInputField}
                   type="date"
                   label="Fecha fin"/>
          </div>
          <div className="col updates-filter-btn-col">
            <div className="form-group">
              <button className="btn bg-vw-dark text-white updates-filter-submit-btn"
                      type="submit"
                      disabled={submitting}>
                <i className="fas fa-sync mr-1"></i>Actualizar
              </button>
            </div>
          </div>
        </div>
        { error && <div className="alert alert-danger mt-2">{error}</div> }
      </form>
    )
  }
}

UpdatesFilterForm = reduxForm({
  form: 'UpdatesFilterForm',
})(UpdatesFilterForm)

const mapStateToProps = state => {
  const updates = state.updates.updates || []
  const machineSerials = [...new Set(updates.map(u => u.Machine).filter(Boolean))].sort()

  return {
    machineSerials,
    initialValues: {
      Machine: '',
      Status: '',
      StartDate: new Date().toISOString().substring(0, 10),
      EndDate: new Date().toISOString().substring(0, 10)
    }
  }
}

const mapDispatchToProps = dispatch => ({
  fetchUpdates: bindActionCreators(fetchUpdates, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(UpdatesFilterForm)
